<template>
    <div class="main" :style="{backgroundImage:'url('+require('../assets/images/bg.png')+')'}">
        <div class="box" :style="{backgroundImage:'url('+require('../assets/images/box.png')+')'}">
            <img src="@/assets/images/logo.png" alt="" class="logo">
            <div class="form">
                <div class="input">
                    <img src="@/assets/images/user.png" alt="">
                    账号
                    <el-input v-model="user"  class="el"></el-input>
                </div>
                <div class="input">
                    <img src="@/assets/images/pwd.png" alt="">
                    密码
                    <el-input v-model="pass" show-password class="el"></el-input>
                </div>
                <el-button type="primary" round class="btn" @click="submitForm()">登录</el-button>
            </div>
        </div>
    </div>
</template>
<script>
    import {
        getlogin
    } from "../api/common";
    export default {
        name: "Login",
        data() {
            return {
                user:"15012967764",
                pass:"00000000"
            }
        },
        watch: {

        },
        mounted() {
            this.$store.commit("setToken", null);
        },
        methods: {
            submitForm(){
                // getlogin(this.user,this.pass).then((res) => {
                //     if (res.data.code==200) {
                //         let token = res.data.data.token;
                //         this.$store.commit("setToken", token);
                //         window.sessionStorage.setItem('token', token);
                //         window.sessionStorage.setItem('isLogin', true);
                //         this.$router.push("SubstationManagement");
                //     }
                // })
                    this.$store.commit("setToken", "1");
                    window.sessionStorage.setItem('token', "1");
                    window.sessionStorage.setItem('isLogin', true);
                    this.$router.push("SubstationManagement");
                  
            }
        }
    };
</script>

<style scoped lang="less">
    .main{
        // background: url('/assets/images/bg.png');
        position: absolute;
        top:0px;
        left: 0px;
        width:100%;
        height: 100%;
        text-align: center;
        .box{
            // background: url('/assets/images/box.png') no-repeat;
            width: 43vw;
            height: 92vh;
            margin:auto;
            display: inline-block;
            background-size: 100% 100%;
            position: absolute;
            top: 50%;
            left: 50%;
            margin-left: -22vw;
            margin-top: -46vh;
            .logo{
                margin-top: 26vh;
            }
            .form{
                margin-top: 9vh;
                .input{
                    margin-top: 5vh;
                    font-size: 18px;
                    img{
                        margin-right: 20px;
                        vertical-align: -5px;
                        width: 20px;
                    }
                    .el{
                      /deep/.el-input__inner{
                            border: 0px;
                            border-bottom: 1px solid #999; 
                            background: transparent;
                            font-size: 18px;
                            border-radius: 0;
                            height: 25px;
                            padding: 0;
                        }
                        margin-left: 20px;
                        width: 198px;
                        
                    }
                }
                .btn{
                    width: 320px;
                    margin-top: 5.5vh;
                }
            }
        }
    }
      
</style>


// WEBPACK FOOTER //
// src/views/Login.vue